/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [leave-space-dialog.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 05.04.20, 18:41
 */

import React, {useState} from 'react';
import DialogBox from "../dialog-box";
import {useDispatch} from "react-redux";
import {useAuthorization} from "../../../selectors";
import {useLanguage} from "../../configuration/configuration";
import {asyncUpdateUserStatus} from "../../../actions";
import {notify} from "../../notifications/notify";

const UpdateStatusDialog = ({user, isOpen, setIsOpen}) => {
    const [dailyStatus, setDailyStatus] = useState('');
    const {isAuthorized, principalUsername} = useAuthorization();
    const dispatch = useDispatch();
    const Lang = useLanguage();

    const updateStatus = () => {
        dispatch(asyncUpdateUserStatus(principalUsername, {status: dailyStatus}, userdata => {
                notify(Lang.dialog.updateStatus.messageDone);
            })
        );
    }

    const handleOnUpdate = () => {
        isAuthorized && updateStatus();
    }

    const handleOnStatusChange = (event) => {
        event.preventDefault();
        setDailyStatus(event.target.value);
    }

    return <DialogBox title={Lang.dialog.updateStatus.title}
                      action={Lang.dialog.updateStatus.action}
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      callback={handleOnUpdate}>
        <div className='mt-4'>
            {Lang.dialog.updateStatus.text(user.firstname)}
        </div>
        <div className='my-3'>
            <label className='form-check-label' htmlFor='statusId'>
                {Lang.dialog.updateStatus.label}
            </label>
            <textarea className='form-control form-textarea'
                      value={dailyStatus}
                      name='dailyStatus'
                      type='text'
                      rows='4'
                      placeholder={Lang.dialog.updateStatus.placeholder}
                      id='statusId'
                      onChange={handleOnStatusChange}/>
        </div>
    </DialogBox>
};

export default UpdateStatusDialog;